module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_reason02-1d1cb94324e8c182bf7da8ee4cbdf313.png";